import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'
import { useAuth } from './useAuth'

/**
 * Returns the advisors row for the currently signed-in user.
 * Resolves by matching advisors.email to auth user email.
 */
export function useCurrentAdvisor() {
  const { user } = useAuth()
  const [advisor, setAdvisor] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user?.email) {
      setAdvisor(null)
      setLoading(false)
      return
    }

    supabase
      .from('advisors')
      .select('id, full_name, email, avatar_url, is_owner')
      .eq('email', user.email)
      .maybeSingle()
      .then(({ data }) => {
        setAdvisor(data ?? null)
        setLoading(false)
      })
  }, [user?.email])

  return { advisor, loading }
}
